/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';

import { CacheService } from '../../global/ng2-cache/services/cache.service';
import { SessionService } from '../../services/session2.service';
import { AdminService } from '../../services/admin.service';
import { ErrorService } from '../../services/error.service';
import { GlobalMessageService } from '../../services/global-message.service';

import { ConfirmDialogComponent } from '../../global/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-admin-workflow',
  templateUrl: './admin-workflow.component.html'
})
export class AdminWorkflowComponent implements OnInit {

  loadingPage = true;
  workflowHistory: any[] = [];

  constructor(private cacheService: CacheService,
              private sessionService: SessionService,
              private adminService: AdminService,
              private errorService: ErrorService,
              private modalService: BsModalService,
              private globalMessageService: GlobalMessageService) { }

  ngOnInit() {
    if (!this.cacheService.get('session')) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.initView();
        }
      )
    }
    else {
      this.initView();
    }
  }

  refresh() {
    this.initView();
  }

  resetBatch(batch) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Please confirm you would like to re-run this batch`,
        confirm: function() {
          me.adminService.resetWorkflowBatch(batch._id).subscribe(
            (result: any) => {
              me.globalMessageService.message('Batch was reset');
              me.initView();
            },
            err => {
              me.globalMessageService.error();
              me.errorService.log(err, 'workflow-history.component', 'resetBatch');
            });
        }
      }
    }));
  }

  pauseBatch(batch) {
    this.adminService.pauseWorkflowBatch(batch._id).subscribe(
      (result: any) => {
        this.globalMessageService.message('Batch was paused');
        this.initView();
      });
  }

  showDetail(batch) {
    if (!batch.show_detail && batch.requestId && batch.requestId.length > 0) {
      this.adminService.getIntegrationLog(batch.requestId).subscribe(
        (result: any) => {
          batch.integrationLog = result || [];
          batch.integrationLog.sort((a,b) => {
            let ad = new Date(a.created_at);
            let bd = new Date(b.created_at);
            if (ad > bd) {
              return 1;
            }
            else {
              return -1;
            }
          });
          batch.show_detail = !batch.show_detail;
        }
      )
    }
    else {
      batch.show_detail = !batch.show_detail;
    }
  }

  private initView() {
    this.loadingPage = true;
    this.adminService.getAllFails().subscribe(
      (result: any) => {
        this.workflowHistory = result;
        this.workflowHistory.forEach((wfh) => {
          wfh.show_detail = false;
        });
        this.loadingPage = false;
      },
      error => {
        console.log(error);
      }
    )
  }

}



// WEBPACK FOOTER //
// ./client/app/admin/admin-workflow/admin-workflow.component.ts